export enum ButtonModifiers {
    normal = "",
    place = "place",
    disabled = "disabled",
    accepted = "accept",
    suspended = "suspended",
    clear = "clear",
    stake = "stake",
    changedStake = "changedStakeBtn"
};